/**
 * The time zone a business in each state most likely keeps. Thirteen states are split across two zones, and
 * for those this is the zone the greater part of the state lives in — Texas is Central although El Paso is
 * not, Florida is Eastern although the panhandle is not. It is an opening answer, not a fact: the field it
 * fills stays on screen and editable, which is what makes a good guess better than an empty select.
 *
 * A postal code would be exact, and nothing here can derive one: that mapping is a dataset — some forty
 * thousand rows at ZCTA level, or a lookup service called from a public page — for a correction that only
 * ever concerns the smaller half of those thirteen states.
 *
 * Every value below is one of `moment.tz.zonesForCountry('US')`, which is the list the select is built from:
 * a zone missing from it would leave the field showing nothing at all.
 */
const TIMEZONE_BY_STATE: Record<string, string> = {
  AL: 'America/Chicago',
  AK: 'America/Anchorage',
  AZ: 'America/Phoenix',
  AR: 'America/Chicago',
  CA: 'America/Los_Angeles',
  CO: 'America/Denver',
  CT: 'America/New_York',
  DC: 'America/New_York',
  DE: 'America/New_York',
  FL: 'America/New_York',
  GA: 'America/New_York',
  HI: 'Pacific/Honolulu',
  IA: 'America/Chicago',
  ID: 'America/Boise',
  IL: 'America/Chicago',
  IN: 'America/Indiana/Indianapolis',
  KS: 'America/Chicago',
  KY: 'America/Kentucky/Louisville',
  LA: 'America/Chicago',
  MA: 'America/New_York',
  MD: 'America/New_York',
  ME: 'America/New_York',
  MI: 'America/Detroit',
  MN: 'America/Chicago',
  MO: 'America/Chicago',
  MS: 'America/Chicago',
  MT: 'America/Denver',
  NC: 'America/New_York',
  ND: 'America/Chicago',
  NE: 'America/Chicago',
  NH: 'America/New_York',
  NJ: 'America/New_York',
  NM: 'America/Denver',
  NV: 'America/Los_Angeles',
  NY: 'America/New_York',
  OH: 'America/New_York',
  OK: 'America/Chicago',
  OR: 'America/Los_Angeles',
  PA: 'America/New_York',
  RI: 'America/New_York',
  SC: 'America/New_York',
  SD: 'America/Chicago',
  TN: 'America/Chicago',
  TX: 'America/Chicago',
  UT: 'America/Denver',
  VA: 'America/New_York',
  VT: 'America/New_York',
  WA: 'America/Los_Angeles',
  WI: 'America/Chicago',
  WV: 'America/New_York',
  WY: 'America/Denver',
};

export const timezoneForState = (state: string): string | null => TIMEZONE_BY_STATE[state] ?? null;
